import Combiners from "abusesa-js/combiners";

import * as TimeUtils from "./TimeUtils";

const INTERVALS = TimeUtils.timeformats;

export default class TimeCombiner extends Combiners.Unique {
    constructor(key, timeformat, opts = {}) {
        if (INTERVALS[timeformat]) {
            timeformat = INTERVALS[timeformat];
        }

        let timezone = opts["timezone"] || 0;
        let map = TimeUtils.round(timeformat, timezone);
        //let format = TimeUtils.format(timeformat, -timezone);
        let format = TimeUtils.format(timeformat);

        let sort = {
            map: function(str) {
                const time = map(str);
                return time ? time.getTime() : null;
            },
            cmpValues: function(a, b) {
                if (a === b) {
                    return 0;
                }
                return a < b ? -1 : 1;
            },
            cmpKeys: function(a, b) {
                if (a === b) {
                    return 0;
                }
                return a < b ? -1 : 1;
            },
            unmap: function(timestamp) {
                return format(new Date(timestamp));
            }
        };

        super(key, {...opts, sort});
    }
}



// WEBPACK FOOTER //
// ./src/kpi/lib/TimeCombiner.js